import type { Article } from "@/types/article";

export default function Attribution({ article }: { article: Article }) {
  const primaryUrl = article.sources?.[0]?.url ?? article.trendUrl;
  const publishedLabel = article.publishedAt
    ? new Date(article.publishedAt).toLocaleString("sv-SE", {
        day: "numeric",
        month: "long",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";
  let faviconUrl: string | null = null;
  if (primaryUrl) {
    try {
      const host = new URL(primaryUrl).hostname;
      faviconUrl = `https://www.google.com/s2/favicons?domain=${host}&sz=32`;
    } catch {
      /* ignore */
    }
  }
  return (
    <div className="k2-meta" style={{ marginTop: "0.75rem" }}>
      {article.source && (
        <span className="k2-source">
          {faviconUrl && (
            <img
              src={faviconUrl}
              alt=""
              width={16}
              height={16}
              className="k2-favicon"
              loading="lazy"
            />
          )}
          {article.source}
        </span>
      )}
      {article.author && (
        <span className="k2-author">Av {article.author}</span>
      )}
      {publishedLabel && <time dateTime={article.publishedAt}>{publishedLabel}</time>}
      {primaryUrl && (
        <a href={primaryUrl} target="_blank" rel="noopener noreferrer nofollow">
          Läs originalet →
        </a>
      )}
    </div>
  );
}